import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

// Puramente apresentacional — nenhum import de service, nenhum hook de leitura do Apollo, nenhum
// fetch próprio. Mirror de StatusChipFinanceiro.tsx (Record+Chip do MUI com bolinha), mas SEM o
// branch de fallback textual (`|| {label: status, ...}`): um valor fora de {WEBHOOK, MANUAL} —
// inclusive null/undefined, o caso comum (a coluna nasceu sem backfill e só é carimbada na
// confirmação PAGO/GRATUITO) — renderiza `null` (nenhum chip), nunca um chip vazio nem a string
// "null". Origem é um eixo semântico distinto de status (StatusChipFinanceiro/PaymentStatusChip)
// e os dois nunca se fundem num único componente.
//
// Ground truth (com.inplay.enums.OrigemConfirmacao / enum OrigemConfirmacao no schema GraphQL,
// inplay-back/src/main/resources/graphql/pagamentoInscricao.graphqls:44-47): exatamente 2
// valores, WEBHOOK e MANUAL — nunca inventar AUTOMATICO/SISTEMA/IUGU/ADMIN.

export interface OrigemConfirmacaoBadgeProps {
  status: 'WEBHOOK' | 'MANUAL' | string | null | undefined;
}

const COLORS: Partial<Record<string, { label: string; color: string; bg: string }>> = {
  WEBHOOK: { label: 'Webhook', color: '#0d6efd', bg: 'rgba(13,110,253,0.2)' },
  MANUAL: { label: 'Manual', color: '#6f42c1', bg: 'rgba(111,66,193,0.2)' },
};

const OrigemConfirmacaoBadge: React.FC<OrigemConfirmacaoBadgeProps> = ({ status }) => {
  const cfg = status ? COLORS[status] : undefined;
  if (!cfg) {
    return null;
  }

  return (
    <Chip
      label={cfg.label}
      className="ps-2"
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }} />}
      size="small"
    />
  );
};

export default OrigemConfirmacaoBadge;
